import { signUserFunction } from './gallery-properties.flow'
import { isGtZeroInteger, toGtZeroInteger } from '../utils/bits'

import { ABOVE_POSTS_LIMIT_DEFAULT } from '../utils/shared-constants'

export default signUserFunction(calcAbovePostsLimit)

function calcAbovePostsLimit(rawVal) {
  const above_posts_limit = toGtZeroInteger(rawVal)
  if (isGtZeroInteger(above_posts_limit)) {
    return above_posts_limit
  } else {
    return ABOVE_POSTS_LIMIT_DEFAULT
  }
}
